import { IHostGroup } from 'pages/Tariff/PriceList/types';

import { IPriceListValue } from '../pages/Tariff/PriceList/PriceList';

export enum ETariffType {
  FIXED = 'FIXED',
  PACKET = 'PACKET',
  PER_MINUTE = 'PER_MINUTE',
  PAUSABLE = 'PAUSABLE',
}
export enum EDuration {
  minutes = 'minutes',
  hours = 'hours',
  days = 'days',
  weeks = 'weeks',
}

export type TTariffGridItem = {
  id: number;
  title: string;
  duration: number;
  cost: number;
  time_from: string;
  time_to: string;
  per_minute: boolean;
  use_global_discounts: boolean;
  has_fixed_finish_time: boolean;
  pausable: boolean;
  booked: boolean;
  disable_sale_receipt_printing: boolean;
};

export type TTariff = {
  title: string;
  cost?: number;
  time_from: string;
  time_to: string;
  duration: number;
  id: number;
  has_fixed_finish_time: boolean;
  host_group?: IHostGroup;
  use_global_discounts?: boolean;
  per_minute: boolean;
  pausable: boolean;
  booked: boolean;
  disable_sale_receipt_printing: boolean;
};

export interface ICostMap {
  title: string;
  value: number;
}

export interface IServerPriceList {
  host_groups: Array<IHostGroup>;
  cost_map: Array<ICostMap>;
}

export interface IServerTariff {
  id: number;
  title: string;
  duration: number;
  sort: number;
  lifetime?: number;
  use_global_discounts: boolean;
  has_fixed_finish_time: boolean;
  is_active: boolean;
  per_minute?: boolean;
  schedules: Array<{ start: number; end: number }>;
  sell_schedules?: Array<{ start: number; end: number }>;
  show_in_shell: boolean;
  show_in_billing: boolean;
  pausable: boolean;
  highlighted: boolean;
  ean?: string;
  price_list: Array<IServerPriceList>;
  is_tracked: boolean;
  use_on_holidays: boolean;
  online_booking_enabled: boolean;
  disable_sale_receipt_printing: boolean;
}

export interface INormalizedTariff {
  title: string;
  type: ETariffType;
  is_active: boolean;
  duration: number | '';
  duration_type: EDuration;
  lifetime: number | '';
  lifetime_type: EDuration;
  price_list: Array<IPriceListValue>;
  days: Array<number>;
  hours: {
    start: string;
    end: string;
  };
  sales_hours: {
    start: string;
    end: string;
  };
  use_global_discounts: boolean;
  show_in_shell: boolean;
  show_in_billing: boolean;
  highlighted: boolean;
  ean: string;
  sort: number;
  use_on_holidays: boolean;
  is_tracked: boolean;
  online_booking_enabled: boolean;
  disable_sale_receipt_printing: boolean;
}

export interface ITimeIntervalReturnValue {
  value: number;
  interval: EDuration;
  title: string;
}
